import { render, staticRenderFns } from "./ConsultButtonDesktop.vue?vue&type=template&id=96044ec4"
import script from "./ConsultButtonDesktop.vue?vue&type=script&lang=js"
export * from "./ConsultButtonDesktop.vue?vue&type=script&lang=js"
import style0 from "./ConsultButtonDesktop.vue?vue&type=style&index=0&id=96044ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports